module.exports = __webpack_public_path__ + "static/IBMPlexMono-Regular-f36c405479ad7917fcb2b9917c7e8122.woff2";